/*******************************************************************************
 * Project：
 * Summary:
 *　　 User state
 * Remarks:
 *    Define state for User
 * History：
 *    CuongLD            2021/05/31    Create
 ******************************************************************************/
import { IUser } from '../../models/user.interface';
export interface IUserState {
  users: IUser[];
  selectedUser: IUser;
}

export const initialUserState: IUserState = {
  users: [],
  selectedUser: null
};

